import { Link } from "react-router-dom";
import { Box, Button, Container, Grid, styled } from "@mui/material";
import NotFoundIcon from "../components/SvgIcons/NotFoundIcon";

const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  padding: "30px 0",
  "@media screen and (max-width:768px)": {
    minHeight: "calc(100vh - 60px)",
  },
  "& .IconWrapper": {
    textAlign: "center",
    "& svg": {
      width: "360px",
      height: "auto",
      "@media screen and (max-width:600px)": {
        width: "calc(100% - 100px)",
      },
      "& .AnimatedPathScale": {
        transformOrigin: "center",
        animation: "scaleUpDown 2s infinite linear",
        "@keyframes scaleUpDown": {
          "0%": { transform: "scale(0.9, 0.9)" },
          "50%": { transform: "scale(1, 1)" },
          "100%": { transform: "scale(0.9, 0.9)" },
        },
      },
    },
    "& .BtnWrapper": {
      "& button": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "7px 22px",
        whiteSpace: "nowrap",
        marginTop: "40px",
        "&:focus": {
          outline: "none",
        },
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
      },
    },
  },
}));
export function Page404() {
  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0} sx={{ justifyContent: "center" }}>
            <Grid item xs={12} md={12}>
              <Box className="IconWrapper">
                <NotFoundIcon />
                <Box className="BtnWrapper">
                  <Link to="/dashboard">
                    <Button>Back to Dashboard</Button>
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </SectionWrapper>
  );
}
